/**
 * AAA IDP Routes
 * 
 */
import * as React from 'react';
import { /* Redirect, */Route, Switch } from 'react-router-dom';
import Home from '../pages/home/Home';
import Details from '../pages/details/Details';
import Summary from '../pages/summary/Summary';
import Payment from '../pages/payment/PaymentPage';
import Completed from '../pages/completed/Completed';
import Confirmation from '../pages/confirmation/Confirmation';
import FourOhFour from '../pages/fourohfour/FourOhFour';
import Login from '../pages/login/Login';
import PageViewTracker from '../components/page-view-tracker/PageViewTracker';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
class Routes extends React.Component {
  render() {
    return /*#__PURE__*/_jsxs(React.Fragment, {
      children: [/*#__PURE__*/_jsx(PageViewTracker, {}), /*#__PURE__*/_jsxs(Switch, {
        children: [/*#__PURE__*/_jsx(Route, {
          path: "/",
          exact: true,
          render: router => /*#__PURE__*/_jsx(Home, {
            ...this.props,
            ...router
          })
        }), /*#__PURE__*/_jsx(Route, {
          path: "/details",
          exact: true,
          render: router => /*#__PURE__*/_jsx(Details, {
            ...this.props,
            ...router
          })
        }), /*#__PURE__*/_jsx(Route, {
          path: "/summary",
          exact: true,
          render: router => /*#__PURE__*/_jsx(Summary, {
            ...this.props,
            ...router
          })
        }), /*#__PURE__*/_jsx(Route, {
          path: "/payment",
          exact: true,
          render: router => /*#__PURE__*/_jsx(Payment, {
            ...this.props,
            ...router
          })
        }), /*#__PURE__*/_jsx(Route, {
          path: "/completed",
          exact: true,
          render: router => /*#__PURE__*/_jsx(Completed, {
            ...this.props,
            ...router
          })
        }), /*#__PURE__*/_jsx(Route, {
          path: "/confirmation",
          exact: true,
          render: router => /*#__PURE__*/_jsx(Confirmation, {
            ...this.props,
            ...router
          })
        }), /*#__PURE__*/_jsx(Route, {
          path: "/member(/login)*(/)*",
          render: () => /*#__PURE__*/_jsx(Login, {})
        }), /*#__PURE__*/_jsx(Route, {
          component: FourOhFour
        })]
      })]
    });
  }
}
export default Routes;